import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { validateEmail } from '../../utils/validators';
import St from '../LoginScreen/LoginScreen.module.css';
import { Button, InputBox, PreAuthContent } from '../../components/new';
import useForgotPasswordFunctions from './useForgotPasswordFunctions';

const ForgotPasswordScreen = ({ history }) => {
  const { t } = useTranslation();
  const { step, email, setEmail, OTP, setOTP, showPassword, setShowPassword, password, setPassword, onVerifyOtpHandler, handleSendEmail, forgotPassword } =
    useForgotPasswordFunctions(history);

  return (
    <PreAuthContent
      pageTitle={t('screens.loginExt.pageTitleForgot')}
      formGreeting={t('screens.loginExt.formGreetingForgot')}
      formTitle={step === 1 ? t('screens.loginExt.formTitleForgotStep1') : t('screens.loginExt.formTitleForgotStep2')}
    >
      {step === 1 ? (
        <form onSubmit={handleSendEmail}>
          <InputBox
            label={t('screens.loginExt.emailLabel')}
            id='rg-email'
            type='email'
            className={`${St.fieldInput} ${email.error ? St.fieldInputError : ''}`}
            placeholder={t('screens.loginExt.emailPlaceholder')}
            autoComplete='email'
            value={email.value}
            onChange={e => {
              const v = e.target.value;
              setEmail({ value: v, error: '', validated: validateEmail(v) });
            }}
            errorMessage={email.error}
            icon='email-new'
          />

          <Button loading={forgotPassword.loading} disabled={forgotPassword.loading} type='submit' label={forgotPassword.loading ? '' : t('screens.loginExt.sendEmail')} />

          <div className={St.formRowCenter}>
            <Link to='/login' className={St.forgotLink}>
              {t('screens.loginExt.backToLogin')}
            </Link>
          </div>
        </form>
      ) : (
        <form onSubmit={onVerifyOtpHandler}>
          <InputBox
            label={t('screens.loginExt.emailLabel')}
            id='rg-email'
            type='email'
            placeholder={t('screens.loginExt.emailPlaceholder')}
            disabled={step === 2}
            autoComplete='email'
            value={email.value}
            onChange={() => {}}
            errorMessage={email.error}
            icon='email-new'
          />

          <InputBox
            label={t('screens.loginExt.secureCodeLabel')}
            id='rg-otp'
            type='otp'
            placeholder={t('screens.loginExt.secureCodePlaceholder')}
            value={OTP.value}
            onChange={e => {
              const v = e.target.value;
              setOTP({ value: v, error: '', validated: v.length === 6 });
            }}
            errorMessage={OTP.error}
            icon='key'
            iconStyle={{ fill: '#c0c0c8' }}
          />

          <InputBox
            label={t('screens.loginExt.passwordLabel')}
            additionalClass={St.fieldSecond}
            id='rg-password'
            type={showPassword ? 'text' : 'password'}
            placeholder={t('screens.loginExt.passwordPlaceholder')}
            autoComplete='current-password'
            value={password.value}
            onChange={e => {
              const v = e.target.value;
              setPassword({ value: v, error: '', validated: v.length >= 8 });
            }}
            errorMessage={password.error}
            icon='password-new'
            toggleIcon={showPassword ? 'eye-open' : 'eye-closed'}
            onPasswordToggle={() => setShowPassword(p => !p)}
            ariaLabelToggle={showPassword ? t('screens.loginExt.hidePassword') : t('screens.loginExt.showPassword')}
          />

          <Button loading={forgotPassword.loading} disabled={forgotPassword.loading} type='submit' label={forgotPassword.loading ? '' : t('screens.loginExt.changePassword')} />
        </form>
      )}

      <div className={St.formFoot}>
        <p>
          {t('screens.loginExt.protectedNote')}
          <br />
          <a href='/#/privacy' target='_blank' rel='noopener noreferrer'>
            {t('screens.loginExt.privacyLink')}
          </a>
          &ensp;·&ensp;
          <a href='/#/terms' target='_blank' rel='noopener noreferrer'>
            {t('screens.loginExt.termsLink')}
          </a>
        </p>
        <div className={St.secureNote}>
          <svg viewBox='0 0 24 24' fill='#48a87c'>
            <path d='M12 2L3 7v5c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-9-5zm-1 14l-4-4 1.41-1.41L11 13.17l5.59-5.59L18 9l-7 7z' />
          </svg>
          {t('screens.loginExt.tlsNote')}
        </div>
      </div>
    </PreAuthContent>
  );
};

export default ForgotPasswordScreen;
